import { formatDate } from "@/modules/common/utils/dateUtils"

export default {
  install(Vue) {
    Vue.config.globalProperties.$formatDate = formatDate
  }
}
